import { Button, Col, Descriptions, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { INPUT_TYPE, MODE_SCREEN } from "../../constants/common.const";

import { DatePicker, Input, Select, Switch } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { useSelector } from "react-redux";
import { workReportNewEquipmentApi } from "../../api/backend/reportNewEquipment";
import { hanmagunoId, misawaId, nagatoId, yuniId } from "../../api/config";
import { KEY, STYLE } from "../../constants/common.const";
import { renderOption } from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classText from "../../models/control/text";
import ReportMachineAttach from "./reportMachineAttach";
import ReportMachineImage from "./reportMachineImage";
import "./workReport.scss";
const FormInput = ({
  valueObject,
  onChange,
  type,
  refer,
  placeHolder,
  afterDate,
  beforeDate,
  disabled,
  haveEmptyOption = true,
  onBlur = () => {},
  showTime,
  format,
  ...other
}) => {
  let InputForm = null;
  switch (type) {
    case "input": {
      InputForm = (
        <div>
          <Input
            ref={refer}
            className={valueObject.error ? STYLE.BORDER_RED : ""}
            value={valueObject.value}
            onChange={onChange}
            placeholder={placeHolder}
            disabled={disabled}
            suffix={other.suffix || ""}
            onBlur={onBlur}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    case "select": {
      InputForm = (
        <Select
          showSearch
          optionFilterProp="children"
          ref={refer}
          className={`${valueObject.error ? STYLE.BORDER_RED : ""} w100`}
          onChange={onChange}
          value={valueObject.value}
          disabled={disabled}
        >
          {renderOption(valueObject.options, haveEmptyOption)}
        </Select>
      );
      break;
    }
    case "date": {
      const checkdate = (date) => {
        if (beforeDate) {
          return date.isSameOrBefore(beforeDate);
        }
        if (afterDate) {
          const affDate = moment(afterDate)
            .add(1, "days")
            .format(KEY.DATE_DEFAULT);
          return date.isSameOrAfter(affDate);
        }
        return false;
      };
      InputForm = (
        <DatePicker
          disabledDate={checkdate}
          placeholder=""
          format={format || KEY.DATE_DEFAULT}
          value={valueObject.value}
          className={`${valueObject.error ? STYLE.BORDER_RED : ""} w100`}
          onChange={onChange}
          disabled={disabled}
          showTime={showTime}
        />
      );
      break;
    }
    case "area": {
      InputForm = (
        <div>
          <TextArea
            rows={3}
            ref={refer}
            className={valueObject.error ? STYLE.BORDER_RED : ""}
            value={valueObject.value}
            onChange={onChange}
            placeholder={placeHolder}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    case "switch": {
      InputForm = (
        <div>
          <Switch
            checked={valueObject.value}
            onChange={onChange}
            className={valueObject.error ? STYLE.BORDER_RED : ""}
          />
          {valueObject.message && (
            <p style={{ color: "red", margin: 0, marginTop: 10, padding: 0 }}>
              {valueObject.message}
            </p>
          )}
        </div>
      );
      break;
    }
    default: {
      return null;
    }
  }
  return <>{InputForm}</>;
};

export const reportDataOrigin = {
  clientName: new classText(""),
  contractorName: new classText(""),
  reportOrInquiry: new classDdl(""),
  reportCategory: new classDdl(""),
  equipmentId: new classText(""),
  reportManagementNumber: new classText(""),
  createDate: new classText(""),
  resubmitDate: new classText(""),
  subject: new classText(""),
  facility: new classText(""),
  location: new classText(""),
  machineForSiteOfficeCode: new classText(""),
  equipmentName: new classText(""),
  modelSpec: new classText(""),
  reporter: new classText(""),
  manager: new classText(""),
  assistantManager: new classText(""),
  occurrenceDateTime: new classText(""),
  occurrenceStatus: new classDdl(""),
  situationDescription: new classText(""),
  //   photo: new classText(""),
  simpleRepairStatus: new classDdl(""),
  notCompletedProposed: new classDdl(""),
  contractorMeasuresAction: new classDdl(""),
  priority: new classDdl(""),
  importance: new classText(""),
  attachedDocument: new classDdl(""),
  quotation: new classText(""),
  clientResponseDate: new classText(""),
  clientResponse: new classDdl(""),
  clientSeal: new classText(""),
  discussionResult: new classDdl(""),
  additionalApprover: new classDdl(""),
};

const ViewReportForm = ({
  mode = MODE_SCREEN.ADD,
  reportData,
  setReportData,
  listAttachMachine = [],
  setListAttachMachine,
  optionNewEquipment = {},
  listImage,
  setListImage,
  showBtn = false,
  showApprove = false,
  customChangeAdded,
  customValueAdded,
  managerRef

}) => {
  const { selectedFactory } = useSelector((state) => state.auth);
  const [showButton, setShowButton] = useState(false);
  const [showApproveAdded, setShowApproveAdded] = useState(false);


  const FACTORY = {
    YUMI: String(yuniId),
    NAGATO: String(nagatoId),
    HAMAGUNO: String(hanmagunoId),
    MISAWA: String(misawaId),
  };
  const [listUserOption, setListUserOption] = useState([]);
  const [listUserHead,setListUserHead] = useState([])
  const fetchUser = async (value) => {
    try {
      const [allUserRes,headUserRes] = await Promise.all([workReportNewEquipmentApi.searchUser({
         type:"user"
      }),workReportNewEquipmentApi.searchUser({
        type:"officeAdmin"
     })])

     const opsAllUser = allUserRes.data.map((item) => ({
      value: `${item.displayName}`,
      key: item.userName,
    }));
    const opsHeadUser = headUserRes.data.map((item) => ({
      value: `${item.displayName}`,
      key: item.userName,
    }));
    setListUserOption(opsAllUser);
    setListUserHead(opsHeadUser)
      
    } catch (e) {
      console.log(e)
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);

  const approveListAll = [{
    title: <span>所長{mode !== MODE_SCREEN.VIEW &&  <span style={{
      color:  "#FF4D4F",
      marginLeft:3
    }} >*</span>}</span>,
    key: "manager",
    value: reportData.manager,
    type: INPUT_TYPE.SELECT,
    span: 2,
    options: listUserHead,
    refer:managerRef,
    haveEmptyOption:false
  },
  {
    title: "副所長",
    key: "assistantManager",
    value: reportData.assistantManager,
    type: INPUT_TYPE.INPUT,
    span: 2,
    type: INPUT_TYPE.SELECT,
    options: listUserOption,
  },
  {
    title: "",
    key: "assistantManager",
    type: INPUT_TYPE.CUSTOM,
    span: 2,
    component: (
      <div className="right">
        <Button
          onClick={() => {
            setShowButton(false);
            setShowApproveAdded(true);
          }}
          className="buttonPC button--outline"
        >
          {" "}
          承認者追加
        </Button>
      </div>
    ),
    show: showButton,
  },
  {
    title: "追加承認者",
    key: "additionalApprover",
    type: INPUT_TYPE.SELECT,
    span: 2,
    value: customValueAdded || reportData.additionalApprover,
    options: listUserOption,
    show: showApproveAdded,
    showModeView:customValueAdded ? true : false,
    customChange:customChangeAdded
  },]
  const approveList = approveListAll.filter(
    (item) =>
      item.show == true ||
      item.show === undefined ||
      item.show === null ||
      item.show === ""
  );


  const listFieldDefinitionAll = [
    {
      title: "委託者名",
      key: "clientName",
      value: reportData.clientName,
      type: INPUT_TYPE.INPUT,
      span: 2,
    },
    {
      title: "受託者名",
      key: "contractorName",
      value: reportData.contractorName,
      type: INPUT_TYPE.INPUT,
      span: 2,
    },
    {
      title: "報告または伺",
      key: "reportOrInquiry",
      value: reportData.reportOrInquiry,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.WORK_REPORT_OR_INQUIRY,
      span: 2,
      show: [FACTORY.YUMI, FACTORY.HAMAGUNO].includes(selectedFactory),
    },
    {
      title: "報告書種類",
      key: "reportCategory",
      value: reportData.reportCategory,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.REPORT_TYPE,
      span: 2,
    },
    {
      title: "設備ID",
      key: "equipmentId",
      value: reportData.equipmentId,
      type: INPUT_TYPE.INPUT,
      span: 2,
      show: [FACTORY.HAMAGUNO].includes(selectedFactory),
    },
    {
      title: "報告書管理番号",
      key: "reportManagementNumber",
      value: reportData.reportManagementNumber,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled:true
    },
    {
      title: "作成日(提出日)",
      key: "createDate",
      value: reportData.createDate,
      type: INPUT_TYPE.DATE,
      span: 2,
      disabled: true,
    },
    {
      title: "再提出日",
      key: "resubmitDate",
      value: reportData.resubmitDate,
      type: INPUT_TYPE.DATE,
      span: 2,
      show: [FACTORY.NAGATO].includes(selectedFactory),
    },
    {
      title: "件名",
      key: "subject",
      value: reportData.subject,
      type: INPUT_TYPE.INPUT,
      span: 2,
    },
    {
      title: "施設",
      key: "facility",
      value: reportData.facility,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled: true,
    },
    {
      title: "場所",
      key: "location",
      value: reportData.location,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled: true,
    },
    {
      title: "機器管理番号",
      key: "machineForSiteOfficeCode",
      value: reportData.machineForSiteOfficeCode,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled: true,
    },
    {
      title: "設備名",
      key: "equipmentName",
      value: reportData.equipmentName,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled: true,
    },
    {
      title: "仕様・型式",
      key: "modelSpec",
      value: reportData.modelSpec,
      type: INPUT_TYPE.INPUT,
      span: 2,
      disabled: true,
    },
    {
      title: "報告者（担当）",
      key: "reporter",
      value: reportData.reporter,
      type: INPUT_TYPE.SELECT,
      span: 2,
      options: listUserOption,
    },
    
   
    {
      title: "発見/発生日時",
      key: "occurrenceDateTime",
      value: reportData.occurrenceDateTime,
      type: INPUT_TYPE.DATE,
      span: 2,
      showTime: true,
      format: "YYYY/MM/DD HH:mm:ss",
    },
    {
      title: "発見/発生状況",
      key: "occurrenceStatus",
      value: reportData.occurrenceStatus,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.OCCURRENCE_STATUS,
      span: 2,
    },
    {
      title: "状況説明",
      key: "situationDescription",
      value: reportData.situationDescription,
      type: INPUT_TYPE.INPUT,
      span: 2,
    },
    // {
    //   title: "写真",
    //   key: "photo",
    //   value: reportData.photo,
    //   type: INPUT_TYPE.INPUT,
    //   span: 2,
    // },
    {
      title: "簡易修繕で処置完了/未処置",
      key: "simpleRepairStatus",
      value: reportData.simpleRepairStatus,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.SIMPLE_REPAIR_STATUS,
      span: 2,
    },
    {
      title: "未処置の場合の対応提案",
      key: "notCompletedProposed",
      value: reportData.notCompletedProposed,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.NOT_COMPLETED_PROPOSED,
      span: 2,
    },
    {
      title: "受託者措置の場合の対応",
      key: "contractorMeasuresAction",
      value: reportData.contractorMeasuresAction,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.CONTRACTOR_MEASURES_ACTION,
      span: 2,
    },
    {
      title: "優先度",
      key: "priority",
      value: reportData.priority,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.PRIORITY_NEW,
      span: 2,
    },
    {
      title: "重要度",
      key: "importance",
      value: reportData.importance,
      type: INPUT_TYPE.INPUT,
      span: 2,
      show: [FACTORY.NAGATO].includes(selectedFactory),
    },
    {
      title: "添付書類",
      key: "attachedDocument",
      value: reportData.attachedDocument,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.YES_NO,
      span: 2,
    },
    {
      title: "見積",
      key: "quotation",
      value: reportData.quotation,
      type: INPUT_TYPE.INPUT,
      span: 2,
      show: [FACTORY.NAGATO, FACTORY.MISAWA].includes(selectedFactory),
    },
    {
      title: "客先回答日",
      key: "clientResponseDate",
      value: reportData.clientResponseDate,
      type: INPUT_TYPE.DATE,
      span: 2,
    },
    {
      title: "客先回答",
      key: "clientResponse",
      value: reportData.clientResponse,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.CLIENT_RESPONSE,
      span: 2,
    },
    {
      title: "客先印鑑",
      key: "clientSeal",
      value: reportData.clientSeal,
      type: INPUT_TYPE.INPUT,
      span: 2,
    },
    {
      title: "協議結果",
      key: "discussionResult",
      value: reportData.discussionResult,
      type: INPUT_TYPE.SELECT,
      options: optionNewEquipment.DISCUSSION_RESULT,
      span: 2,
      show: [FACTORY.NAGATO, FACTORY.MISAWA].includes(selectedFactory),
    },
  ];
  const listFieldDefinition = listFieldDefinitionAll.filter(
    (item) =>
      item.show == true ||
      item.show === undefined ||
      item.show === null ||
      item.show === ""
  );

  let indexReporter = listFieldDefinition.findIndex(i => i.key === "reporter");

  const handleChange = (key, type,customChange) => (e) => {
    const value =
      type === INPUT_TYPE.SELECT || type === INPUT_TYPE.DATE
        ? e
        : e.target.value;

    if (type === INPUT_TYPE.INPUT && String(value).length > 255) {
      return;
    }
    if(customChange){
      customChange(value)
    }
    else{
      setReportData({
        ...reportData,
        [key]: {
          ...reportData[key],
          value,
        },
      });
    }
    
  };

  const renderItem = (item) => {
    if (item.component) return item.component;
    return (mode === MODE_SCREEN.VIEW  && !item.showModeView)? (
      item.value.value
    ) : (
      <FormInput
        haveEmptyOption={item.haveEmptyOption}
        // refer={(el) => (inputRefs.current[item.key] = el)}
        onChange={handleChange(item.key, item.type,item.customChange)}
        valueObject={{ ...item.value, options: item.options || [] }}
        type={item.type}
        disabled={item.disabled}
        format={item.format}
        showTime={item.showTime}
        refer={item.refer}
        
      />
    );
  };
  useEffect(() => {
    // if (mode === MODE_SCREEN.ADD) {
    //   setReportData({
    //     ...reportData,
    //     createDate: { ...reportData.createDate, value: moment() },
    //   });
    // }
  }, [mode]);

  useEffect(() => {
    setShowButton(showBtn ? true : false);
  }, [showBtn]);
  useEffect(() => {
    setShowApproveAdded(showApprove ? true :false);
  }, [showApprove]);
  return (
    <Row gutter={[8, 8]}>
      <Col span={18}>
      <Descriptions
          className="customEquipmentDes report-machine-des-equal"
          size="small"
          column={2}
          bordered
          
        >
          {listFieldDefinition.slice(0,indexReporter + 1).map((item, index) => (
            <Descriptions.Item
            style={{ width: "28%",display:item.isNone ? "none" :"" }}
              key={item.key}
              label={
                <span
                  style={{ color: item.required ? "#ff2255" : "" }}
                  className="labelInputEquipment"
                >
                  {item.title}
                </span>
              }
              span={1}
              labelStyle={{ fontWeight: "bold", width: "22%" }}
              contentStyle={{ padding: "4px 4px",}}
            >
              {renderItem(item)}
            </Descriptions.Item>
          ))}
        </Descriptions>
        <div className="mb15"></div>
      <Descriptions
          className="customEquipmentDes report-machine-des-equal"
          size="small"
          column={2}
          bordered
          
        >
          {approveList.map((item, index) => (
            <Descriptions.Item
            style={{ width: "28%",display:item.isNone ? "none" :"" }}
              key={item.key}
              label={
                <span
                  style={{ color: item.required ? "#ff2255" : "" }}
                  className="labelInputEquipment"
                >
                  {item.title}
                </span>
              }
              span={1}
              labelStyle={{ fontWeight: "bold", width: "22%" }}
              contentStyle={{ padding: "4px 4px",}}
            >
              {renderItem(item)}
            </Descriptions.Item>
          ))}
        </Descriptions>
        <div className="mb15"></div>
        <Descriptions
          className="customEquipmentDes report-machine-des-equal"
          size="small"
          column={2}
          bordered
          
        >
          {listFieldDefinition.slice(indexReporter+1).map((item, index) => (
            <Descriptions.Item
            style={{ width: "28%",display:item.isNone ? "none" :"" }}
              key={item.key}
              label={
                <span
                  style={{ color: item.required ? "#ff2255" : "" }}
                  className="labelInputEquipment"
                >
                  {item.title}
                </span>
              }
              span={1}
              labelStyle={{ fontWeight: "bold", width: "22%" }}
              contentStyle={{ padding: "4px 4px",}}
            >
              {renderItem(item)}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Col>
      <Col span={6}>
        <div>
          <ReportMachineImage
            listImage={listImage}
            setListImage={setListImage}
            mode={mode}
          />
        </div>
        <ReportMachineAttach
          listAttachMachine={listAttachMachine}
          setListAttachMachine={setListAttachMachine}
          mode={mode}
        />
      </Col>
    </Row>
  );
};

export default ViewReportForm;
